define('GameDayCore/GDUtil/resources/DataSourceSelector',['require','exports','module','jquery','../../GDModel/enums/datasources/DefaultDatasources','datasource-manager/datasource-manager'],function(require,exports,module) {
	var $ = require("jquery"),
        DefaultDatasources = require("../../GDModel/enums/datasources/DefaultDatasources"),
        DatasourceManager = require( "datasource-manager/datasource-manager" ),

        defaults = {
			expires: 9,
			timeout: 30,
			retries: 1,
			priority: 2,
			mimetype: "text/xml",

			PROD: {
				gd_flat: "/gdcross",
				gd_tfs: "/tfs/tfs?file=",
				tfsTimecodeQuery: "&timecode="
			},
	
			QA: {
				gd_flat: "/gdcross",
				gd_tfs: "/tfs/tfs?file=",
				tfsTimecodeQuery: "&timecode="
			},
	
			TEST: {
				gd_flat: "http://gdx.mlb.com",
				gd_tfs: "http://lwsa.mlb.com/tfs/tfs?file=",
				tfsTimecodeQuery: "%26timecode="
			},
	
			TEST_QA: {
				gd_flat: "http://gd.qa.mlb.com",
				gd_tfs: "http://qa.mlb.com/tfs/tfs?file=",
				tfsTimecodeQuery: "%26timecode="
			}
		};

	exports.addSources = function($overrides){
		var srcs = { },
            resolvedList = $.extend(DefaultDatasources, $overrides);

       	DatasourceManager.update('defaults',defaults);
       	DatasourceManager.add(resolvedList);
	};
});
